/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import './UtilitiesReport.scss'
import { useParams } from 'react-router-dom';
import { Button, Table, Form, FormControl, Image, Modal, Row, Col } from 'react-bootstrap';
import Header from '../Header';
import SideBar from '../SideBar';
// auth imports
import jwt_decode from "jwt-decode";
import { serverUrl, fetchLandlordIds } from "../../../serverUrl";
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import loaderImageGif from "../../../assets/img/kodi_loader.gif";


function UtilitiesReport(Apartmentid) {
  // sidebar and header functions
  const [showSidebar, setShowSidebar] = useState(true);
  function toggleSidebar() {
    setShowSidebar(!showSidebar);
  }
  const [isLoading, setIsLoading] = useState(false);

  // getting the id and finding the apparment details
  const { id } = useParams();
  const isAllProperties = id === 'all';
  const [landlordId, setLandlordId] = useState(null);
    // get the houses and the tenants that are within that house
  const accessToken = localStorage.getItem("authTokens");
  // get the access token
  const parsedTokens = JSON.parse(accessToken);
  const access = parsedTokens.access;


  // headers access token
  const config = {
    headers: { Authorization: `Bearer ${access}` }
  }
  // decoding the token so that i can get the user id
  const decodedToken = jwt_decode(accessToken);


  const [selectedHouses, setSelectedHouses] = useState([])

  // the filter to work for the month and years


  // get the current month so that i can filter out the total income
  const months = Array.from({ length: 12 }, (_, i) => {
    const month = new Date(new Date().getFullYear(), i, 1);
    return month.toLocaleString('default', { month: 'long' });
  });
  // Get the current month automatically
  const currentDate = new Date();
  const currentMonthIndex = new Date().getMonth();
  const currentMonth = months[currentMonthIndex];

  // get the months till today
  const monthsTillToday = Array.from({ length: currentMonthIndex + 1 }, (_, i) => {
    const month = new Date(currentDate.getFullYear(), i, 1);
    return month.toLocaleString('default', { month: 'long' });
  });

  // get the years
  const currentYear = new Date().getFullYear();
  const startYear = currentYear;

  const years = Array.from({ length: 21 }, (_, i) => startYear - i);


  // display 12 churches per page
  const [currentYearPage, setCurrentYearPage] = useState(0);
  const itemsPerPageYear = 12;
  const totalPagesYear = Math.ceil(years.length / itemsPerPageYear);

  const handlePrevYearPage = () => {
    setCurrentYearPage(currentYearPage - 1);
  };

  const handleNextYearPage = () => {
    setCurrentYearPage(currentYearPage + 1);
  };

  const startIndexYear = currentYearPage * itemsPerPageYear;
  const endIndexYear = startIndexYear + itemsPerPageYear;
  const displayedYears = years.slice(startIndexYear, endIndexYear);


  // get the months and years filtered out
  const [monthFilterActive, setMonthFilterActive] = useState("")
  const [yearFilterActive, setYearFilterActive] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const handleCloseModal = () => {

    setShowModal(false);
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
    setShowModal(true);
  };

  const handleMonthButtonClick = (month) => {
    setSelectedMonth(month);
    if (yearFilterActive) {
      localStorage.removeItem('yearUtilities');
    }
    localStorage.setItem("monthUtilities", month);
    setShowModal(false);
    window.location.reload();

  };

  const handleYearButtonClick = (year) => {
    setSelectedYear(year);
    if (monthFilterActive) {
      localStorage.removeItem('monthUtilities');
    }

    localStorage.setItem("yearUtilities", year);
    setShowModal(false);
    window.location.reload();

  };


  useEffect(() => {
    const loadData = async () => {
      // get if the filter is set
      let setMonthFilter = localStorage.getItem("monthUtilities");
      setMonthFilterActive(setMonthFilter)

      let setYearFilter = localStorage.getItem("yearUtilities")
      setYearFilterActive(setYearFilter)

      const landlordIdValue = isAllProperties ? await fetchLandlordIds() : null;
      if (isAllProperties) {
        setLandlordId(landlordIdValue);
        if (!landlordIdValue) {
          return;
        }
      }

      const reportParam = isAllProperties ? `landlord_id=${landlordIdValue}` : `apartment_id=${id}`;

      if (setYearFilter) {
        serverUrl.get(`/tenant/generate_annual_income_report/?${reportParam}&year=${setYearFilter}&income_category=expense`, config)
          .then((res) => {
            setSelectedHouses(res.data.incomeList)
          })
          .catch((error) => {
            console.log(error)
          })
      }
      else {
        if (!setMonthFilter) {
          // get the houses linked to the apartment
          serverUrl.get(`/tenant/generate_month_income_report/?${reportParam}&month=${currentMonth}&year=${currentYear}&income_category=expense`, config)
            .then((res) => {
              setSelectedHouses(res.data.incomeList)
            })
            .catch((error) => {
              console.log(error)
            })
        }
        else {
          serverUrl.get(`/tenant/generate_month_income_report/?${reportParam}&month=${setMonthFilter}&year=${currentYear}&income_category=expense`, config)
            .then((res) => {
              setSelectedHouses(res.data.incomeList)
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    };

    loadData();
  }, []);
  // searching function and sorting functionalities
  const [sortType, setSortType] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  const handleSort = (sortField) => {
    setSortType(sortField);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setSelectedRow(null); // Reset selected row when user starts a new search
  };

  const sortedData = selectedHouses.sort((a, b) => {
    const sortValueA = typeof a[sortType] === "string" ? a[sortType].toLowerCase() : a[sortType];
    const sortValueB = typeof b[sortType] === "string" ? b[sortType].toLowerCase() : b[sortType];
    if (sortOrder === "asc") {
      return sortValueA > sortValueB ? 1 : -1;
    } else {
      return sortValueA < sortValueB ? 1 : -1;
    }
  });

  const filteredData = sortedData.filter((item) => {
    const searchableFields = Object.values(item).join(" ").toLowerCase();
    return searchableFields.includes(searchQuery.toLowerCase());
  });

  // design the table to display 10 each per table
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = currentPage === totalPages - 1 ? filteredData.length : startIndex + itemsPerPage;
  const displayedItems = filteredData.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const exportCSV = () => {
    let csvRows = [];
    if (yearFilterActive) {
      // Yearly: match table columns for yearly
      csvRows.push(['Name', 'House', 'Utility', 'Amount', 'Units', 'Date Paid', 'Invoice Month']);
      selectedHouses.forEach(item => {
        csvRows.push([
          item.tenant_name ?? '',
          item.tenant_house ?? '',
          item.expense_category ?? '',
          item.tenant_amount ?? '',
          item.unit ?? '',
          item.tenant_date_paid ?? '',
          item.month ?? ''
        ]);
      });
    } else {
      // Monthly: match table columns for monthly
      csvRows.push(['Name', 'House', 'Utility', 'Amount', 'Units', 'Date Paid']);
      selectedHouses.forEach(item => {
        csvRows.push([
          item.tenant_name ?? '',
          item.tenant_house ?? '',
          item.expense_category ?? '',
          item.tenant_amount ?? '',
          item.unit ?? '',
          item.tenant_date_paid ?? ''
        ]);
      });
    }
    // Escape CSV values and join rows
    const csvContent = csvRows
      .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(csvBlob, 'utilities_report.csv');
  };

  function handleDownload() {

    setIsLoading(true);
    // we will have to loop through all the months but with the selected year

    const annualExpenseParam = isAllProperties
      ? `landlord_id=${landlordId}`
      : `apartment_id=${id}`;
    serverUrl.get(`/tenant/generate_annual_income_report/?${annualExpenseParam}&year=${currentYear}&income_category=expense&download=true`, config)
      .then((res) => {
        // create a download url for the pdf and then automatically download the pdf
        const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'utilities_report.pdf');
        document.body.appendChild(link);
        link.click();
        toast.success('Successfully Downloaded Your Utilities Report');
        setIsLoading(false);

      })
      .catch((error) => {
        console.log(error);
      })


  }

  // filter button to remove the filter
  const handleReset = () => {

    // Clear the tokens from local storage and redirect to the login page
    localStorage.removeItem('monthUtilities');
    localStorage.removeItem('yearUtilities');
    toast.success('Successfully Reset The Utilities Report Filter!');
    window.location.reload()
  };

  // if the data is loading show a message
  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
          <img src={loaderImageGif} alt="Loading..." style={{width:"400px"}} />

      </div>
    );
  }

  return (
    <>
     
      <div className='UtilitiesReport'>


        {/* list of the tenants of the apartment and payment details */}
        <div className='tasks ' >
          <h2 style={{ color: "#c0392b" }}>utilities income</h2>

          {/* when any of the filters is on */}
          <div className='d-flex justify-content-between'>
            <Form.Select size='sm' className='formCal' onChange={handleSelectChange} style={{ width: "20%" }}>
              <option selected disabled>Filter Report By:</option>
              <option>Monthly</option>
              <option>Yearly</option>
            </Form.Select>

            {monthFilterActive ?
              <p className='filterText'>Utilities Income Report For {monthFilterActive} </p>
              : yearFilterActive ?
                <p className='filterText'>Utilities Income Report For {yearFilterActive}</p>
                :
                <p className='filterText' style={{ marginRight: "31rem" }}>Utilities Income Report For {currentMonth}</p>

            }

            {monthFilterActive || yearFilterActive ?
              <Button className='text-white filterButton' onClick={handleReset}>Reset Filter</Button>

              :
              <></>}
          </div>

          {/* modal to be displayed */}
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header className='bg-primary text-white' closeButton>
              <Modal.Title>Filter By {selectedOption}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedOption === currentMonth ?
                (
                  <>
                    <p>{currentMonth}</p>

                  </>
                )
                : selectedOption === "Monthly" ?
                  (
                    <>
                      <Form>
                        <Row className="flex-wrap justify-content-between">
                          {months.map((month) => (
                            <Col key={month} xs={6} sm={4} md={4} className="mt-3">
                              <Button className='btn btn-primary text-white w-75' style={{ marginInline: '0.5rem' }} onClick={() => handleMonthButtonClick(month)}>
                                {month}
                              </Button>
                            </Col>
                          ))}
                        </Row>

                      </Form>
                    </>

                  )
                  : selectedOption === "Yearly" ?
                    (
                      <>
                        <Form>
                          <Row className="flex-wrap justify-content-between">
                            {displayedYears.map((year) => (
                              <Col key={year} xs={6} sm={4} md={4} className="mt-3">
                                <Button className='btn btn-primary text-white w-75' style={{ marginInline: '0.5rem' }} onClick={() => handleYearButtonClick(year)}>
                                  {year}
                                </Button>
                              </Col>
                            ))}
                          </Row>
                          <div className="mt-3 d-flex justify-content-center">
                            {currentYearPage > 0 && (
                              <Button variant="outline-primary" onClick={handlePrevYearPage}>
                                Previous
                              </Button>
                            )}
                            {currentYearPage < totalPagesYear - 1 && (
                              <Button variant="outline-primary" onClick={handleNextYearPage}>
                                Next
                              </Button>
                            )}
                          </div>
                        </Form>
                      </>
                    ) :
                    (
                      <>
                        <p>Date</p>
                      </>
                    )
              }
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={handleCloseModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <div className='d-flex justify-content-between'>

            <div>
              <Button className='btn btn-success text-white me-3' onClick={exportCSV}> EXCEL <i className='bi bi-file-earmark-excel '></i></Button>
              <Button className='btn btn-danger text-white me-3' onClick={handleDownload} >PDF <i className='bi bi-file-pdf-fill'></i></Button>
            </div>
            <Form className="searchBar">
              <FormControl type="text" placeholder="Search" onChange={handleSearch} />
            </Form>
          </div>
          <Table className='table'>
            {yearFilterActive ?
              <>
                <thead className="">
                  <th>Tenant Image</th>
                  <th onClick={() => handleSort("tenant_name")}>Name<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("tenant_house")}>House<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("apartment_name")}>Apartment<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("expense_category")}>Utility<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("tenant_amount")}>Amount<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("unit")}>Units<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("tenant_date_paid")}>Date Paid<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("month")}>Invoice Month<i className='bi bi-chevron-expand'></i></th>


                </thead>
                <tbody>
                  {displayedItems.map((expenses, index) =>
                    <tr>
                      <td style={{ width: "15%" }}>
                        <Image src={expenses.tenant_image} style={{ width: "20%", borderRadius: "50%" }} />
                      </td>
                      <td>{expenses.tenant_name}</td>
                      <td>{expenses.tenant_house}</td>
                      <td>{expenses.apartment_name || '-'}</td>
                      <td>{expenses.expense_category}</td>
                      <td>{expenses.tenant_amount}</td>
                      <td>{expenses.unit}</td>
                      <td>{expenses.tenant_date_paid}</td>
                      <td>{expenses.month}</td>
                    </tr>
                  )}

                </tbody>
              </>

              :
              <>
                <thead className="">
                  <th>Tenant Image</th>
                  <th onClick={() => handleSort("tenant_name")}>Name<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("tenant_house")}>House<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("apartment_name")}>Apartment<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("expense_category")}>Utility<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("tenant_amount")}>Amount<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("unit")}>Units<i className='bi bi-chevron-expand'></i></th>
                  <th onClick={() => handleSort("tenant_date_paid")}>Date Paid<i className='bi bi-chevron-expand'></i></th>


                </thead>
                <tbody>
                  {displayedItems.map((expenses, index) =>
                    <tr>
                      <td style={{ width: "15%" }}>
                        <Image src={expenses.tenant_image} style={{ width: "20%", borderRadius: "50%" }} />
                      </td>
                      <td>{expenses.tenant_name}</td>
                      <td>{expenses.tenant_house}</td>
                      <td>{expenses.apartment_name || '-'}</td>
                      <td>{expenses.expense_category}</td>
                      <td>{expenses.tenant_amount}</td>
                      <td>{expenses.unit}</td>
                      <td>{expenses.tenant_date_paid}</td>
                    </tr>
                  )}

                </tbody>
              </>
            }

          </Table>
          {/* get the display of the items 5 per page */}
          <div className="pagination">
            <button onClick={handlePrevPage} disabled={currentPage === 0}>
              &lt;
            </button>
            <span>{`${startIndex + 1}-${endIndex} of ${selectedHouses.length}`}</span>
            <button onClick={handleNextPage} disabled={currentPage === totalPages - 1}>
              &gt;
            </button>
          </div>

          <h2 className='text-center text-primary'>Total amount : KES 0</h2>
        </div>


      </div>
    </>
  )
}

export default UtilitiesReport
